import React, { useEffect, useState } from 'react';
import { Button, Multiselect, Notification, Select, Spinner } from '@rio-cloud/rio-uikit';
import { optionsAdministrative, optionsFinancial, optionsGroupsMatriz, optionsTechnical, optionsVolksTotalPortal, supportStatusOptions } from '../../../../../support/constants';
import { createGroupTopic, editeGroupTopic } from '../../../../../../api/tas';

interface CreatTopicProps {
    onSuccess: () => void;
    onCancel: () => void;
    data?: MatrizForm;
}

interface MatrizForm {
    id?: number;
    subject: string;
    subtopic: string;
    groupIds: string[];
}

const UserMatrizForm: React.FC<CreatTopicProps> = ({
    onSuccess,
    onCancel,
    data,
}) => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const hasEdit = !!data?.id;
    const [formData, setFormData] = useState<MatrizForm>({
        subject: '',
        subtopic: '',
        groupIds: []
    });

    const validateForm = (): boolean => {
        const newErrors: Record<string, string> = {};

        if (!formData.subject) {
            newErrors.subject = 'Obrigatório';
        }

        if (!formData.subtopic) {
            newErrors.subtopic = 'Obrigatório';
        }

        if (!formData.groupIds.length) {
            newErrors.groupIds = 'Obrigatório'
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);



        try {
            if (data?.id) {
                await editeGroupTopic(data?.id, formData);
            } else {
                await createGroupTopic(formData);
            }
            onSuccess();
            Notification.success(hasEdit ? 'Matriz editada com sucesso' : 'Matriz criada com sucesso')
        } catch (error) {
            
            Notification.error(hasEdit ? 'Não foi possível editar a matriz no momento': 'Não foi possível criar a matriz no momento')
        } finally {
            setLoading(false);
        }

    };

    const handleInputChange = (field: keyof MatrizForm, value: string | string[]) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));

        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: '',
            }));
        }
    };

    const optionsSubtopic = [
        ...optionsFinancial,
        ...optionsVolksTotalPortal,
        ...optionsTechnical,
        ...optionsAdministrative,
    ].sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));

    useEffect(() => {
        if (data) {
            setFormData({
                groupIds: data.groupIds,
                subject: data.subject,
                subtopic: data.subtopic
            })
        }
    }, [data])

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label htmlFor="subject" className="block font-medium text-gray-700 mb-2">
                        Assunto *
                    </label>
                    <Select
                        id='subject'
                        placeholder='Selecione'
                        value={[formData.subject]}
                        options={supportStatusOptions}
                        onChange={item => handleInputChange('subject', item?.id as string)}
                    />
                    {errors.subject && (
                        <p className="text-red-600 text-sm mt-1">{errors.subject}</p>
                    )}
                </div>

                <div>
                    <label htmlFor="subtopic" className="block font-medium text-gray-700 mb-2">
                        Tema *
                    </label>
                    <Select
                        id='subtopic'
                        placeholder='Selecione'
                        value={[formData.subtopic]}
                        options={optionsSubtopic}
                        onChange={item => handleInputChange('subtopic', item?.id as string)}
                    />

                    {errors.subtopic && (
                        <p className="text-red-600 text-sm mt-1">{errors.subtopic}</p>
                    )}
                </div>

                <div>
                    <label htmlFor="groupids" className="block font-medium text-gray-700 mb-2">
                        Grupos *
                    </label>
                    <Multiselect
                        id='groupids'
                        placeholder='Selecione'
                        value={formData.groupIds}
                        options={optionsGroupsMatriz}
                        useFilter
                        noItemMessage='Nenhum grupo encontrado'
                        onChange={response => handleInputChange('groupIds', response)}
                    />
                    {errors.groupIds && (
                        <p className="text-red-600 text-sm mt-1">{errors.groupIds}</p>
                    )}
                </div>
            </div>

            <div className="flex justify-end space-x-3 pt-6">
                <Button
                    bsStyle={Button.DEFAULT}
                    onClick={onCancel}
                    disabled={loading}
                >
                    Cancelar
                </Button>
                <Button
                    bsStyle={Button.PRIMARY}
                    type="submit"
                    disabled={loading}
                    iconName={loading ? undefined : "rioglyph-check"}
                    onClick={handleSubmit}
                >
                    {loading ? (
                        <div className="flex items-center">
                            <Spinner />
                            Adicionando...
                        </div>
                    ) : (
                        'Adicionar'
                    )}
                </Button>
            </div>
        </form>
    );
};

export default UserMatrizForm;

